// Shared tier metadata for DIY Legal — single source of truth for the frontend.
export const TIER_ORDER = ["free", "basic", "complete", "court_ready_plus"];

export const TIERS = {
  en: {
    free: {
      key: "free",
      name: "Free",
      price: "$0",
      period: "forever",
      tagline: "Start Here — I Got Served. Now What?",
      lookup_key: null,
      uploads_label: "10 document uploads",
      upload_limit: 10,
      navigator_sessions: 0,
      features: [
        '"I Got Served. Now What?" onboarding',
        "Basic case identification & action checklist",
        "Basic Case Timeline",
        "Basic document explanation",
        "Basic Courtroom Coach",
        "Basic legal-information resources",
        "Basic court preparation checklist",
      ],
    },
    basic: {
      key: "basic",
      name: "Basic",
      price: "$19.99",
      period: "per year",
      tagline: "More Tools. More Organization. More Confidence.",
      lookup_key: "basic_yearly",
      uploads_label: "24 document uploads / year",
      upload_limit: 24,
      navigator_sessions: 0,
      features: [
        "Everything in Free, plus:",
        "Expanded document explanation",
        "Expanded Case Timeline",
        'Expanded "What Happens Next?"',
        "Court preparation resources & document organization",
        "Email / text support",
        "Community Court Navigator help using the platform",
      ],
    },
    complete: {
      key: "complete",
      name: "Complete",
      price: "$69.99",
      period: "per year",
      tagline: "Research. Organize. Prepare.",
      lookup_key: "complete_yearly",
      uploads_label: "120 document uploads / year",
      upload_limit: 120,
      navigator_sessions: 0,
      badge: "Most popular",
      features: [
        "Everything in Basic, plus:",
        "Legal Research Assistant (Rule → Source → Plain-language → Why It Matters)",
        "Document & Argument Builder (timelines, motions, declarations, discovery)",
        "Every result cites its authoritative source",
        "Draft label on every generated document",
      ],
    },
    court_ready_plus: {
      key: "court_ready_plus",
      name: "Court Ready+",
      price: "$99.99",
      period: "per year",
      tagline: "The Complete DIY Court Navigation Experience",
      lookup_key: "court_ready_plus_yearly",
      uploads_label: "Unlimited document uploads",
      upload_limit: -1,
      navigator_sessions: 12,
      badge: "Best value",
      features: [
        "Everything in Complete, plus:",
        "Unlimited document uploads",
        "12 virtual Community Court Navigator sessions / year",
        "Court Ready book — full digital access",
        "Priority email / text support",
      ],
    },
  },
  es: {
    free: {
      key: "free",
      name: "Gratis",
      price: "$0",
      period: "siempre",
      tagline: "Empieza aquí — Me demandaron. ¿Y ahora qué?",
      lookup_key: null,
      uploads_label: "10 cargas de documentos",
      upload_limit: 10,
      navigator_sessions: 0,
      features: [
        'Introducción "Me demandaron. ¿Y ahora qué?"',
        "Identificación básica del caso y lista de acciones",
        "Cronología básica del caso",
        "Explicación básica de documentos",
        "Entrenador de sala básico",
        "Recursos básicos de información legal",
        "Lista básica de preparación para la corte",
      ],
    },
    basic: {
      key: "basic",
      name: "Básico",
      price: "$19.99",
      period: "por año",
      tagline: "Más herramientas. Más organización. Más confianza.",
      lookup_key: "basic_yearly",
      uploads_label: "24 cargas de documentos / año",
      upload_limit: 24,
      navigator_sessions: 0,
      features: [
        "Todo lo de Gratis, más:",
        "Explicación ampliada de documentos",
        "Cronología ampliada del caso",
        '"¿Qué pasa después?" ampliado',
        "Recursos de preparación para la corte y organización de documentos",
        "Soporte por correo / texto",
        "Ayuda de una Navegadora Comunitaria para usar la plataforma",
      ],
    },
    complete: {
      key: "complete",
      name: "Completo",
      price: "$69.99",
      period: "por año",
      tagline: "Investiga. Organiza. Prepárate.",
      lookup_key: "complete_yearly",
      uploads_label: "120 cargas de documentos / año",
      upload_limit: 120,
      navigator_sessions: 0,
      badge: "Más popular",
      features: [
        "Todo lo de Básico, más:",
        "Asistente de Investigación Legal (Regla → Fuente → Lenguaje sencillo)",
        "Constructor de Documentos y Argumentos (cronologías, mociones, declaraciones, descubrimiento)",
        "Cada resultado cita su fuente autoritativa",
        'Etiqueta "BORRADOR" en cada documento generado',
      ],
    },
    court_ready_plus: {
      key: "court_ready_plus",
      name: "Court Ready+",
      price: "$99.99",
      period: "por año",
      tagline: "La experiencia completa de navegación de corte DIY",
      lookup_key: "court_ready_plus_yearly",
      uploads_label: "Cargas de documentos ilimitadas",
      upload_limit: -1,
      navigator_sessions: 12,
      badge: "Mejor valor",
      features: [
        "Todo lo de Completo, más:",
        "Cargas de documentos ilimitadas",
        "12 sesiones virtuales al año con una Navegadora Comunitaria",
        "Libro Court Ready — acceso digital completo",
        "Soporte prioritario por correo / texto",
      ],
    },
  },
};

export function tierRank(tier) {
  const i = TIER_ORDER.indexOf(tier);
  return i < 0 ? 0 : i;
}

export function hasTier(userTier, minimum) {
  return tierRank(userTier) >= tierRank(minimum);
}
